import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';

const FeaturedVendorsSection = () => {
  // Featured Partners, Spring/Summer 2026 'Candyland Romance' photoshoot team
  const vendors = [
    {
      name: 'Hilton Malta',
      category: 'Venue',
      location: "St. Julian's, Malta",
      image: 'https://images.unsplash.com/photo-1595360323074-1f06be35aa33?w=600&h=400&fit=crop',
      link: 'https://www.hilton.com/en/hotels/mlahitw-hilton-malta/'
    },
    {
      name: 'Siemenjov Galdes Weddings',
      category: 'Photography',
      location: 'Malta & Gozo',
      image: 'https://images.unsplash.com/photo-1707192325647-dd4889599e12?w=600&h=400&fit=crop',
      link: 'https://www.siemenjovgaldes.com'
    },
    {
      name: 'Alamango',
      category: 'Wedding Dress: Solene by Morilee',
      location: 'Sliema, Malta',
      image: 'https://images.unsplash.com/photo-1766149481900-328c59e7f17a?w=600&h=400&fit=crop',
      link: 'https://www.alamango.com.mt'
    },
    {
      name: 'Vanity Lounge',
      category: 'Hair',
      location: 'Malta',
      image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600&h=400&fit=crop',
      link: 'https://www.instagram.com/vanitylounge.malta/'
    },
    {
      name: 'Makeup by Michaela',
      category: 'Makeup',
      location: 'Malta',
      image: 'https://images.unsplash.com/photo-1503236823255-94609f598e71?w=600&h=400&fit=crop',
      link: 'https://www.facebook.com/p/Michaela-Buttigieg-The-Makeup-Artist-100094268821226/'
    },
    {
      name: 'So Ellie',
      category: 'Bridesmaids',
      location: 'Malta',
      image: 'https://images.unsplash.com/photo-1535632787350-4e68ef0ac584?w=600&h=400&fit=crop',
      link: 'https://by-elly.myshopify.com/'
    },
    {
      name: 'Bortex Fine Tailoring',
      category: 'Groomswear',
      location: 'Valletta, Malta',
      image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop',
      link: 'https://bortex.com.mt'
    },
    {
      name: 'Monsoon Malta',
      category: 'Flower Girls & Page Boys',
      location: 'Sliema, Malta',
      image: 'https://customer-assets.emergentagent.com/job_fdaaf3ca-6030-4a2e-8a59-67f6d31ca384/artifacts/v4hjdz47_51_51400280170_6-350x435.webp',
      link: 'https://www.facebook.com/MonsoonChildrenMalta'
    },
    {
      name: 'Elite Transport Malta',
      category: 'Classic Wedding Cars',
      location: 'Malta',
      image: '/images/vendors/elite-vintage-car.jpg',
      link: 'https://www.elitetransportmt.com/wedding-cars'
    },
    {
      name: 'Booth! Malta',
      category: 'Photobooth',
      location: 'Malta',
      image: 'https://static.prod-images.emergentagent.com/jobs/4d821d9a-f1d9-4d63-ae58-b7c29b0e73b7/images/6df5dff206f588600b22fa29b03e1363ffb7a0fd8ced042c10f95796046328c6.png',
      link: 'https://boothmalta.com'
    },
    {
      name: 'The Khinos',
      category: 'Live Band',
      location: 'Malta',
      image: 'https://customer-assets.emergentagent.com/job_ba5a83e9-a81b-438c-bcb8-bdf67a8056f4/artifacts/3dr4j3ks_20260422_SUMMER--2026_292.jpg',
      link: '#'
    },
    {
      name: "Damian's Cocktails",
      category: 'Bar Services',
      location: 'Malta',
      image: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=600&h=400&fit=crop',
      link: 'https://www.damianscocktailsmalta.com'
    },
    {
      name: 'Flowers by Nanette',
      category: 'Florals',
      location: 'Birkirkara, Malta',
      image: 'https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=600&h=400&fit=crop',
      link: 'https://www.facebook.com/nanettefloraldesign/'
    },
    {
      name: 'Clement Jewellers',
      category: 'Jewellery',
      location: 'Birkirkara, Malta',
      image: 'https://images.unsplash.com/photo-1736154577794-65871df026ea?w=600&h=400&fit=crop',
      link: 'https://clementjewellers.com'
    },
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#DE92A9]/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#DE92A9]/5 rounded-full translate-x-1/2 translate-y-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p
            className="text-base md:text-lg mb-4 italic"
            style={{ fontFamily: '"Playfair Display", serif', color: '#DE92A9' }}
          >
            Spring & Summer 2026: Candyland Romance
          </p>
          <h2 
            className="text-4xl md:text-5xl lg:text-6xl mb-4 tracking-tight"
            style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
          >
            Featured Partners
          </h2>
          <p className="text-base max-w-2xl mx-auto" style={{ color: '#757B7F' }}>
            The team behind our Candyland Romance editorial, from venue and gown to florals, hair, beauty, music and more.
          </p>
        </div>

        {/* Vendors Grid with Images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 mb-12">
          {vendors.map((vendor, index) => (
            <a
              key={vendor.name}
              href={vendor.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 flex flex-col"
              data-testid={`vendor-card-${vendor.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {/* Image (smaller, banner style) */}
              <div className="relative aspect-[16/9] overflow-hidden">
              <img 
                src={vendor.image} 
                alt={`${vendor.name}, ${vendor.category} in Malta`}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />

                {/* Featured Badge */}
                <div className="absolute top-2 left-2 bg-[#DE92A9] text-white text-[10px] px-2 py-1 rounded tracking-wider">
                  FEATURED
                </div>
              </div>

              {/* Content (bigger names, on white) */}
              <div className="p-4 flex-1 flex flex-col">
                <p
                  className="text-[10px] tracking-[0.2em] uppercase mb-2"
                  style={{ color: '#DE92A9' }}
                >
                  {vendor.category}
                </p>
                <h3
                  className="text-lg md:text-xl leading-tight mb-2 group-hover:text-[#DE92A9] transition-colors"
                  style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
                >
                  {vendor.name}
                </h3>
                <p className="text-xs flex items-center gap-1 mt-auto" style={{ color: '#757B7F' }}>
                  <MapPin size={12} />
                  {vendor.location}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* View All Partners CTA */}
        <div className="text-center">
          <Link 
            to="/partners"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-sm tracking-wider font-medium transition-all duration-300 hover:gap-4 group"
            style={{ 
              backgroundColor: '#DE92A9', 
              color: 'white',
              boxShadow: '0 4px 14px 0 rgba(222, 146, 169, 0.25)'
            }}
            data-testid="view-all-partners-btn"
          >
            VIEW ALL PARTNERS
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedVendorsSection;
